import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type CustomValidationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
};

export const CustomValidationModal = ({
  open,
  onClose,
  onConfirm,
  loading,
}: CustomValidationModalProps) => {
  const { t } = useTranslation(["boCustoms", "common"]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      title={t("validationModal.title")}
      description={t("validationModal.description")}
      footer={
        <div className="flex w-full gap-2">
          <Button
            type="button"
            variant="outline"
            className="flex-1"
            disabled={loading}
            onClick={onClose}
          >
            {t("common:actions.cancel")}
          </Button>
          <Button type="button" className="flex-1" disabled={loading} onClick={onConfirm}>
            {loading ? (
              <Loader2 className="mx-auto size-4 animate-spin" />
            ) : (
              t("validationModal.submit")
            )}
          </Button>
        </div>
      }
    />
  );
};
